<script setup lang="ts">
import { toStall, type StallData } from "~/lib/stall";

const route = useRoute()
const { area } = route.params

definePageMeta({
  title: "模擬店大賞 - QRコード発行"
})

function onClick(stall: StallData) {
  open(location.origin + `/2024/best-booth-award/qr/generate?id=${stall['ID'].toLocaleLowerCase()}`)
}
</script>

<template>
  <article class="flex flex-col items-center max-w-[900px] mx-auto px-[8px]">
    <Ribbon class="mt-6 mb-8 text-md md:text-2xl">
      模擬店大賞 - QRコード発行
    </Ribbon>

    <XlsxData :path="`/data/booth/模擬店.xlsx`" :transformer="data => toStall(data)" >
      <template #default="{ data }">
        <div class="grid gap-4 grid-cols-1 md:grid-cols-2 mb-8">
          <template v-for="(stall, i) in data.filter(stall => area.includes(stall['エリアID'].toLowerCase()))">
            <StallItem
              :data="stall" 
              :index="i"
              @click="onClick(stall)"
            />
          </template>
        </div>
      </template>
    </XlsxData>

    <div class="mb-4">
      <NuxtLink class="btn btn-primary" to="/booth">
        前のページに戻る
      </NuxtLink>
    </div>
  </article>
</template>